import { render, staticRenderFns } from "./ImportsTable.vue?vue&type=template&id=0ad28aff&"
import script from "./ImportsTable.vue?vue&type=script&lang=js&"
export * from "./ImportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports